import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { gql } from '@apollo/client'
import { DEPOSITION_REPORT_QUERY } from '../../../graphql.js'
import { Table, Alert, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { getData, getInputParams, sortColumnClicked } from '../CustomUtils'
import ColumnHeadings from '../ColumnHeadings.js'
import ReportHeading from '../ReportHeading.js'
import ParameterValues from '../ParameterValues.js'
import ReportGrid from '../ReportGrid'
import { getToken, getTenant } from '../../../utils'
import '../Custom.css'

const DEPOSITION_REPORT = gql(DEPOSITION_REPORT_QUERY)

export default function DepositionReport({ location }) {
  console.log('DepositionReport rendered:', location)

  const navigate = useNavigate()
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  function handleClick(caseId) {
    console.log(caseId)
    function tokenSuccess(jwt) {
      console.log(jwt)
      const link = document.createElement('a')
      document.body.appendChild(link)

      link.href = `${process.env.REACT_APP_SERVER}/pdf/${getTenant()}/custom/NJAsbestos/depositionReportPDF/deposition_report?caseId=${caseId}&jwt=${jwt}`
      link.setAttribute('type', 'hidden')
      link.setAttribute('target', '_blank')
      link.click()
    }

    function tokenError(error) {
      console.log('PDFLink: ', JSON.stringify(error))
    }
    getToken(tokenSuccess, tokenError)
  }
  
  function pdfLink(data) {
    return <Button color="primary" size="sm" onClick={() => handleClick(data)}>Deposition Report</Button>
  }

  useEffect(() => {
    getData(location, DEPOSITION_REPORT, 'depositionReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const columnFormatters = [
      { columnNumber: 5, formatter: pdfLink, align: 'center' },
    ]
    return (
      <div className="custom-scroll">
        <Table bordered style={{ width: 'auto', minWidth: '800px', margin: 'auto'}}>
          <ReportHeading title={'Outstanding Research Chart'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} inputs={getInputParams(location)} sortColumnClicked={sortColumnClicked} location={location} navigate={navigate} setResults={setResults} />
            <ReportGrid results={results} columnFormatters={columnFormatters} />
          </tbody>
        </Table>
      </div>
    )
  }
}